
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Logo from '../common/Logo';

export const AuthLayout = () => {
  // Replace with actual auth check logic
  const isAuthenticated = false;
  
  // If user is already authenticated, redirect to dashboard
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-bytesplash-light to-white flex flex-col">
      <header className="w-full max-w-7xl mx-auto px-4 py-6">
        <Logo className="text-bytesplash-primary" />
      </header>
      
      <main className="flex-1 flex items-center justify-center">
        <div className="w-full max-w-md">
          <Outlet />
        </div>
      </main>
      
      <footer className="py-6 text-center text-bytesplash-gray-500 text-sm">
        &copy; {new Date().getFullYear()} ByteSplash Learning Management System
      </footer>
    </div>
  );
};
